module.exports = __webpack_public_path__ + "static/media/car-drawing.8c4202a5.png";